/* Программ тай холбоотой тогтмол утгууд болон enum ууд */

export const ACTIONS = {
  EXCEL: "1",
  PRINT: "2",
};

export const pageMotion = {
  initial: {
    opacity: 0,
  },
  in: {
    opacity: 1,
  },
  out: {
    opacity: 0,
  },
};

export const IsEnable = {
  Идэвхтэй: 1,
  Идэвхгүй: 0,
};

export const PaymentType = {
  Бэлнээр: 1,
  Картаар: 2,
  Мобайлаар: 3,
  Зээл:4
};

export const SaleType = {
  Борлуулалт: 1,
  Буцаалт: 2,
};

export const ReceiptType = {
  Борлуулалт: "Борлуулалт",
  Захиалга: "Захиалга",
  Буцаалт: "Буцаалт",
  Хаалт: "Хаалт",
  Карт: "Карт",
  Баркод: "Баркод",
};

export const PaperSize = {
  m58: 1,
  m80: 2,
};

export const Admin = 1;
export const Cashier = 2;
export const Manager = 3;

export const MenuPerm = 1;
export const BuyingPerm = 2;
export const SalePerm = 3;
export const SettingsPerm = 4;
export const ReportPerm = 5;
export const DashPerm = 6;
export const DiscountPerm = 7;
export const KitchenPerm = 8;

export const UserPerm = [
  {
    label: "Меню бүртгэл",
    value: MenuPerm,
  },
  {
    label: "Материалын татан авалт",
    value: BuyingPerm,
  },
  {
    label: "Захиалга заал",
    value: SalePerm,
  },
  {
    label: "Тохиргоо",
    value: SettingsPerm,
  },
  {
    label: "Тайлан",
    value: ReportPerm,
  },
  {
    label: "Дашбоард",
    value: DashPerm,
  },
  {
    label: "Хямдрал",
    value: DiscountPerm,
  },
  {
    label: "Гал тогоо",
    value: KitchenPerm,
  },
];
export const MasterAdminRole = [1, 2, 3, 4, 5, 6, 7, 8];

export const CashierRole = [3];

export const ManagerRole = [1, 2, 3];
export const ChefRole = [8];

export const MainWindow = {
  Zaal: 1,
  Menu: 2,
  Tailan: 3,
  Tohirgoo: 4,
};

export const LicenseType = {
  Demo: 1,
  Main: 2,
  All: 99,
};
